import {createUseStyles} from 'react-jss';

export default createUseStyles({
  tabTitle: {
    display: 'table-cell',
    width: '1%', // Arbitrary width to support auto-width table columns on older browsers
    padding: '1em',
    backgroundColor: props => (props.isSelected ? '#fff' : '#ebebeb'),
    fontSize: '1.2em',
    textAlign: 'center',
    cursor: props => (props.isSelected ? 'default' : 'pointer'),
    border: props => (props.isSelected ? 'none' : '1px solid #c4c4c4'),
    borderTop: 'none',
    transition: '0.4s background-color',
    
    '&:hover': {
      backgroundColor: props => (props.isSelected ? '#fff' : '#e3e3e3'),
    },
  
    '&:active': {
      backgroundColor: '#dcdcdc',
    },
  
    '&:first-child': {
      borderLeft: 'none',
    },
  
    '&:last-child': {
      borderRight: 'none',
    },
  },
});
